// authUtils.js

export const Logout = () => {
    // debugger
    localStorage.clear(); // Clear the access token from local storage
    // You can also clear other items from local storage or perform additional logout actions here
    window.location.reload()
  };
  